module.exports = __webpack_public_path__ + "static/img/pin-landing-rate-inactive.382f781.svg";